import request from '@/utils/request'

// 查询列表
export function apiMdmItemMaintenanceMasterPlanList (query) {
  return request({
    url: '/mdm/mdmItemMaintenance/masterPlanList',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiMdmItemMaintenanceNewExport (data) {
  return request({
    url: '/mdm/mdmItemMaintenance/v2/masterPlanExport',
    method: 'post',
    data: data
  })
}

// 修改
export function apiMdmItemMaintenanceMasterPlanEdit (data) {
  return request({
    url: '/mdm/mdmItemMaintenance/masterPlanEdit',
    method: 'put',
    data: data
  })
}

// 标准套转换系数
export function apiItemAttributeCoefficientCalculation (data) {
  return request({
    url: `/mdm/itemAttribute/coefficientCalculation?itemCode=${data.itemCode}`,
    method: 'put',
    data: data
  })
}
